module.exports = __webpack_public_path__ + "25979366faf5e84513316a345b66914d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/centene_2021_chart.png
// module id = 1647
// module chunks = 0